import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';

export const usePrimeursHeader = () => {
  const { isLoading, data, refetch } = useTypedQuery('get', '/primeurs/header');

  return {
    isLoading,
    kpis: (data as any)?.kpis || [],
    feed: (data as any)?.feed || [],
    refetch
  };
};

export const usePrimeursLive = (options: { vintage?: string } = {}) => {
  const { isLoading, data, refetch } = useTypedQuery('get', '/primeurs/live', {
    params: {
      query: {
        vintage: options.vintage || undefined
      }
    }
  });

  return {
    isLoading,
    live: data || { checks: [], minimum_prices: [] },
    client_wines: (data as any)?.client_wines || [],
    refetch
  };
};

export const usePrimeursPreparation = () => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/primeurs/preparation'
  );

  return {
    isLoading,
    prepa: data || { price_vs_score: [], primeur_vs_web: [], all_notes: [] },
    client_wines: (data as any)?.client_wines || [],
    rival_wines: (data as any)?.rival_wines || [],
    refetch
  };
};

export const usePrimeursRecap = (options: { vintage?: string } = {}) => {
  const { isLoading, data, refetch } = useTypedQuery('get', '/primeurs/recap', {
    params: {
      query: {
        vintage: options.vintage || undefined
      }
    }
  });

  return {
    isLoading,
    recap: data || { histo_price: [], kpis: [], store_stats: [] },
    client_wines: (data as any)?.client_wines || [],
    refetch
  };
};
